<div class="tug-game">
  <!-- Header -->
  <div class="game-header">
    <span class="round-counter">
      <span class="current">{{ getRoundNum() | arabicNumber:currLang }}</span>
      <span class="sep">/</span>
      <span class="total">{{ getTotalRounds() | arabicNumber:currLang }}</span>
    </span>
    <span class="game-title">⚔️ {{ currLang === 'ar' ? 'شد الحبل' : 'Tug of War' }}</span>
    <div class="header-actions">
      <app-game-sound-control></app-game-sound-control>
      <button class="header-action-btn help-btn" (click)="showInfo = true">
        <span class="help-icon">?</span>
      </button>
    </div>
  </div>
  <app-game-info-modal *ngIf="showInfo" [gameType]="'tug_of_war'" (close)="showInfo = false"></app-game-info-modal>

  <!-- Main 3-column layout -->
  <div class="tug-columns">
    <!-- Team A Question Panel (Left) -->
    <div class="team-panel team-a-panel" [class.submitted]="teamASubmitted">
      <div class="panel-header team-a-header" (click)="showTeamADropdown = !showTeamADropdown">
        <span class="panel-team-name">{{ teamAName }} <span class="dropdown-arrow" [class.open]="showTeamADropdown">&#9662;</span></span>
        <span class="panel-score">{{ teamA?.score || 0 | arabicNumber:currLang }}</span>
      </div>
      <div class="team-dropdown" *ngIf="showTeamADropdown">
        <div class="dropdown-student" *ngFor="let s of teamA?.students">
          <span class="student-dot" [style.background]="teamA?.color"></span>
          <span class="student-name">{{ currLang === 'ar' ? s.name.ar : s.name.en }}</span>
        </div>
      </div>

      <!-- Result overlay -->
      <div class="panel-result" *ngIf="teamASubmitted && teamAResult">
        <div class="result-text" [class.correct]="teamAResult.isCorrect" [class.incorrect]="!teamAResult.isCorrect">
          {{ getResultText(teamAResult) }}
        </div>
        <div class="result-xp" *ngIf="teamAResult.xpEarned > 0">+{{ teamAResult.xpEarned | arabicNumber:currLang }} XP</div>
      </div>

      <!-- Question -->
      <div class="panel-question" *ngIf="!teamASubmitted && teamAQuestion">
        <div class="question-text" [class.rtl]="currLang === 'ar'">
          {{ getQuestionText(teamAQuestion) }}
        </div>
        <div class="options-list">
          <button *ngFor="let option of teamAQuestion.options; let i = index"
                  class="option-btn"
                  [class.selected]="teamASelectedOption === option.id"
                  (click)="selectOptionA(option.id)">
            <span class="option-label">{{ getOptionLabel(option.id) }}</span>
            <span class="option-text" [class.rtl]="currLang === 'ar'">{{ getOptionText(option) }}</span>
          </button>
        </div>
        <button class="submit-btn"
                [class.active]="teamASelectedOption"
                [disabled]="!teamASelectedOption"
                (click)="submitTeamA()">
          {{ currLang === 'ar' ? 'تأكيد' : 'Submit' }}
        </button>
      </div>
    </div>

    <!-- Center: Rope Arena -->
    <div class="center-arena">
      <app-tug-of-war-rope
        [position]="state?.ropePosition || 0"
        [teamAColor]="teamA?.color || '#2196F3'"
        [teamBColor]="teamB?.color || '#F44336'"
        [teamAName]="teamAName"
        [teamBName]="teamBName"
        [teamAScore]="teamA?.score || 0"
        [teamBScore]="teamB?.score || 0"
        [timerValue]="timerValue"
        [isPulling]="isPulling">
      </app-tug-of-war-rope>
    </div>

    <!-- Team B Question Panel (Right) -->
    <div class="team-panel team-b-panel" [class.submitted]="teamBSubmitted">
      <div class="panel-header team-b-header" (click)="showTeamBDropdown = !showTeamBDropdown">
        <span class="panel-team-name">{{ teamBName }} <span class="dropdown-arrow" [class.open]="showTeamBDropdown">&#9662;</span></span>
        <span class="panel-score">{{ teamB?.score || 0 | arabicNumber:currLang }}</span>
      </div>
      <div class="team-dropdown" *ngIf="showTeamBDropdown">
        <div class="dropdown-student" *ngFor="let s of teamB?.students">
          <span class="student-dot" [style.background]="teamB?.color"></span>
          <span class="student-name">{{ currLang === 'ar' ? s.name.ar : s.name.en }}</span>
        </div>
      </div>

      <!-- Result overlay -->
      <div class="panel-result" *ngIf="teamBSubmitted && teamBResult">
        <div class="result-text" [class.correct]="teamBResult.isCorrect" [class.incorrect]="!teamBResult.isCorrect">
          {{ getResultText(teamBResult) }}
        </div>
        <div class="result-xp" *ngIf="teamBResult.xpEarned > 0">+{{ teamBResult.xpEarned | arabicNumber:currLang }} XP</div>
      </div>

      <!-- Question -->
      <div class="panel-question" *ngIf="!teamBSubmitted && teamBQuestion">
        <div class="question-text" [class.rtl]="currLang === 'ar'">
          {{ getQuestionText(teamBQuestion) }}
        </div>
        <div class="options-list">
          <button *ngFor="let option of teamBQuestion.options; let i = index"
                  class="option-btn"
                  [class.selected]="teamBSelectedOption === option.id"
                  (click)="selectOptionB(option.id)">
            <span class="option-label">{{ getOptionLabel(option.id) }}</span>
            <span class="option-text" [class.rtl]="currLang === 'ar'">{{ getOptionText(option) }}</span>
          </button>
        </div>
        <button class="submit-btn"
                [class.active]="teamBSelectedOption"
                [disabled]="!teamBSelectedOption"
                (click)="submitTeamB()">
          {{ currLang === 'ar' ? 'تأكيد' : 'Submit' }}
        </button>
      </div>
    </div>
  </div>
</div>
